var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-container"},[_c('el-button',[_vm._v("查询")]),_vm._v(" 我是谁 ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }